const eColors = [
    {
        emotion: 'Feliz',
        color: '#F2CF3D '
    },
    {
        emotion: 'Triste',
        color: '#134e89'
    },
    {
        emotion: 'Enojo',
        color: '#CC4E4E'
    },
    {
        emotion: 'Alegria',
        color: '#88B73E'
    },
    {
        emotion: 'Neutral',
        color: '#999999'
    },
    {
        emotion: 'Ira',
        color: '#501c12'
    },
    {
        emotion: 'Frustración',
        color: '#DB7D1F'
    },
    {
        emotion: 'Frustration',
        color: '#DB7D1F'
    },
    {
        emotion: 'Frustracion',
        color: '#DB7D1F'
    }
];

export { eColors }